import React from 'react';
import MagstimTable from './MagstimTable';
import styled from 'styled-components';
import routeManager from 'RouteManager';

import { CurrentLang } from 'common';

class MagstimTableTreaterAssessmentsPatientHistory extends MagstimTable {

	initForSelect = (data, heightPx) => {
		// console.log('#1957 MagstimTableTreaterAssessmentsPatientHistory.initForSelect', data);
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		const isMagstimAdmin = (undefined === routeManager.isMagstimAdmin) || routeManager.isMagstimAdmin;
		return {
			columns: [
                { title: CurrentLang().note_type_patient, property: 'PatientFullName', optional: true, isSearchable: !isMagstimAdmin },
				{ title: CurrentLang().clinical_assessment_rating_scale, property: 'RatingScaleName' },
				{ title: CurrentLang().clinical_assessment_self_assessed, property: 'IsSelfAssessment', formatter: this.formatBool },
				{ title: CurrentLang().patient_history_plan_title, property: 'TreatmentPlanName' },
				{ title: CurrentLang().clinical_assessment_column_average_baseline, property: 'FirstScoreFraction', optional: true, formatter: this.formatFraction },
				{ title: CurrentLang().clinical_assessment_column_average_last_recorded, property: 'LatestScoreFraction', optional: true, formatter: this.formatFraction },
				{ title: CurrentLang().clinical_assessment_column_improvement, property: 'SumDeltaRS_Latest_First', formatter:  this.formatPercentTo2DecimalPlace   },
				{ title: CurrentLang().clinical_assessment_column_assessment_count_in_range, property: 'RangeClinicalAssessmentCount' },

			],
			data: data
		};
	}
	
	render() {
		return (
			<Wrapper>
				<div className="item-margin" id={this.props.div_name} ref={this._divTable} background="red" ></div>
			</Wrapper>
		);
	}
}

const Wrapper = styled.div`

`;

export default MagstimTableTreaterAssessmentsPatientHistory;